import type { AntennaSignalResult } from '@/features/jobs/types/job-detail'

const signalResultLabels: Record<AntennaSignalResult, string> = {
  good: 'Good',
  good_marginal: 'Good / Marginal',
  marginal: 'Marginal',
  marginal_bad: 'Marginal / Bad',
  bad: 'Bad',
}

export const formatSignalResult = (signalResult: AntennaSignalResult) =>
  signalResultLabels[signalResult]
